<i class="icon" [style.--icon-url]="currentUrl" [style.--icon-font-size]="currentFontSize"
  [style.--icon-width]="currentWidth || '1em'" [style.--icon-height]="currentHeight || '1em'"
  [attr.data-source]="source"></i>